
// Creates a new promise that has the resolve and reject methods without the need to create a closure.
//
// This is just a ployfill to "Promise.withResolvers()" that might not be available on older browsers.
export class PromiseWithResolvers<T> {

    promise = new Promise<T>((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
    });

    resolve(_value: T | PromiseLike<T>): void {
        // rewritten by callback-function
    };

    reject(_reason?: any): void {
        // rewritten by callback-function
    };

}
